import directusServer from "./directus/directusGraphQLInstance"
import { rethrowIfDatabaseUnavailable } from "./errors/database"

const getAllPosts = async () => {
  try {
    const response = await directusServer.query(`
			query allBlogPostsURLs {
				posts(
					sort:  "-date_created",
					filter: { status: { _eq: "published" } }
					limit: 400,
				) {
					id,
					slug,
					title,
					featured,
					role,
					evidence_metric,
					date_created,
					category {
						category_id {
							slug
						}
					}
				}
				webpage_config {
					cv_file {
						id
						filename_download
						filesize
					}
				}
			}
  `)
    // console.log(response);

    return response
  } catch (error) {
    rethrowIfDatabaseUnavailable(error)
    console.error(error)
    return null
  }
}

export default getAllPosts
